import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IGetSecurityQuestionResponse } from '../../../../services/strong-customer-authentication/model';
import { UtilityService } from '../../../../services/utility.service';
import { ContentService } from '../../../../services/content.service';
import { IContentSecurityQuestions } from '../../../../models/content';
import { GTMTracking } from '../../../../enums/google-analytics-tracking';

@Component({
  selector: 'dynamic-account-question-form',
  templateUrl: 'dynamic-account-question-form.component.html',
})
export class DynamicAccountQuestionFormComponent implements OnChanges {
  @Input()
  question: IGetSecurityQuestionResponse;
  @Input()
  loading = true;
  @Input()
  showAnotherQuestionLink = false;
  @Input()
  showIHaveAnUnlockCodeLink = false;
  @Input()
  showDontKnowTheAnswerLink = false;
  @Input()
  showEnterPasswordInsteadLink = false;
  @Input()
  contactUsLink = null;
  @Input()
  contactUsText = null;
  @Output()
  onShowAnotherQuestion = new EventEmitter();
  @Output()
  onUseUnlockCode = new EventEmitter();
  @Output()
  onAnswerUnknown = new EventEmitter();
  @Output()
  onUsePassword = new EventEmitter();
  @Output()
  onSubmit = new EventEmitter();
  @Output()
  trackEvent = new EventEmitter();
  @Output()
  trackEventPageView = new EventEmitter();

  private securityQuestionsTexts: IContentSecurityQuestions;
  dynamicAccountQuestionForm: FormGroup;
  answer: FormControl;

  constructor(
    private utilityService: UtilityService,
    private contentService: ContentService
  ) {
    this.loadContentData();
    this.createForm();
  }

  ngOnChanges(changes) {
    if (!this.showAnotherQuestionLink) {
      this.trackEventPageView.emit(GTMTracking.AnsweringSecurityQuestionTwo);
    }
  }

  get formValid() {
    return (
      this.dynamicAccountQuestionForm.dirty &&
      this.dynamicAccountQuestionForm.valid
    );
  }

  get questionText() {
    return this.securityQuestionsTexts[this.question.question];
  }

  selectAnswerQuestionTrack() {
    const eventTrackingName = this.showAnotherQuestionLink
      ? GTMTracking.RegistrationSecurityQuestionOneAnswer
      : GTMTracking.RegistrationSecurityQuestionTwoAnswer;
    this.trackEvent.emit(eventTrackingName);
  }

  createForm() {
    this.answer = new FormControl({});
    this.dynamicAccountQuestionForm = new FormGroup({
      answer: this.answer,
    });
  }

  formatAnswer(input: string) {
    const value = Number(input);
    if (isNaN(value)) {
      return input;
    }
    return this.utilityService.formatCurrency(value);
  }

  onSubmitAnswer() {
    this.onSubmit.emit(this.answer.value);
  }

  onShowAnotherQuestionClick(e: Event) {
    e.preventDefault();
    this.trackEvent.emit(GTMTracking.RegistrationShowMeAnotherQuestion);
    this.onShowAnotherQuestion.emit();
  }

  onUnlockCodeClick(e: Event) {
    e.preventDefault();
    this.onUseUnlockCode.emit();
  }

  onAnswerUnknownClick(e: Event) {
    e.preventDefault();
    const eventTrackingName = this.showAnotherQuestionLink
      ? GTMTracking.RegistrationDoNotKnowTheAnswer
      : GTMTracking.RegistrationDoNotKnowTheAnswerTwo;
    this.trackEvent.emit(eventTrackingName);
    this.onAnswerUnknown.emit();
  }

  onEnterPasswordInsteadClick(e: Event) {
    e.preventDefault();
    this.onUsePassword.emit();
  }

  private loadContentData(): void {
    this.contentService.getData().then((content) => {
      this.securityQuestionsTexts = content.securityQuestions;
    });
  }
}
